import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { WheelState, WheelOption, WheelSettings } from '../types'

const defaultSettings: WheelSettings = {
  speed: 5,
  duration: 3,
  theme: 'default',
  soundEnabled: true,
  confettiEnabled: true,
}

const defaultOptions: WheelOption[] = [
  { id: '1', text: 'YES' },
  { id: '2', text: 'NO' },
]

export const useWheelStore = create<WheelState>()(
  persist(
    (set, get) => ({
      options: defaultOptions,
      settings: defaultSettings,
      isSpinning: false,
      result: null,
      history: [],
      mode: 'normal',
      setMode: (mode) => set({ mode }),
      pendingElimination: null,
      accumulationCounts: {},
      resetAccumulation: () => set({ accumulationCounts: {} }),
      soundEnabled: true,
      toggleSound: () => set((state) => ({ soundEnabled: !state.soundEnabled }) as Partial<WheelState>),

      addOption: (text: string) => {
        const newOption: WheelOption = {
          id: Date.now().toString(),
          text,
        }
        set((state) => ({
          options: [...state.options, newOption],
        }))
      },

      removeOption: (id: string) => {
        set((state) => ({
          options: state.options.filter((option) => option.id !== id),
        }))
      },

      updateOption: (id: string, text: string) => {
        console.log('Updating option in store:', id, text)
        set((state) => ({
          options: state.options.map((option) =>
            option.id === id ? { ...option, text } : option
          ),
        }))
      },

      setSettings: (settings: Partial<WheelSettings>) => {
        set((state) => ({
          settings: { ...state.settings, ...settings },
        }))
      },

      spin: () => {
        console.log('Spin function called')
        const { options, mode } = get()
        console.log('Current options:', options)
        if (options.length === 0) {
          console.log('No options available')
          return
        }

        // Randomly select a result
        const randomIndex = Math.floor(Math.random() * options.length)
        const result = options[randomIndex]
        console.log('Selected result:', result)
        
        set((state) => {
          let newState: any = {
            isSpinning: true,
            result,
            history: [...state.history, result],
          }
          if (mode === 'elimination') {
            newState.pendingElimination = result
          }
          if (mode === 'accumulation') {
            const counts = { ...state.accumulationCounts }
            counts[result.id] = (counts[result.id] || 0) + 1
            newState.accumulationCounts = counts
          }
          return newState
        })
      },

      spinEnd: () => {
        const { mode, pendingElimination } = get()
        if (mode === 'elimination' && pendingElimination) {
          set((state) => ({
            isSpinning: false,
            options: state.options.filter((option) => option.id !== pendingElimination.id),
            pendingElimination: null,
          }))
        } else {
          set({ isSpinning: false })
        }
      },

      clearResult: () => {
        set({ result: null })
      },

      clearHistory: () => {
        set({ history: [] })
      },

      reset: () => {
        set({
          options: defaultOptions,
          settings: defaultSettings,
          isSpinning: false,
          result: null,
          history: [],
          accumulationCounts: {},
        })
      },
    }),
    {
      name: 'wheel-storage',
      partialize: (state) => ({
        // Only persist settings, not options or other states
        settings: state.settings,
      }),
    }
  )
) 